import { Component, OnInit, Inject, ChangeDetectionStrategy} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IrbClientsService } from '../irb-clients.service';
import { AppService } from '@irb/app.service';
import { IExternalAccountRequest } from '../irb-clients.model';
import { IrbAppEvents } from '@irb/app.events';
import { AssignedAccountsService } from "@irb/irb-clients/assigned-accounts/assigned-accounts-service";
import {DeleteExternalAccountsDialogGridLayoutService} from "@irb/irb-clients/delete-external-accounts-dialog/delete-external-accounts-dialog.grid-layout.service";

@Component({ standalone: false,
  selector: 'irb-delete-external-accounts-dialog',
  templateUrl: './delete-external-accounts-dialog.component.html',
  styleUrls: ['./delete-external-accounts-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class DeleteExternalAccountsDialogComponent implements OnInit {

  externalAccounts: Array<any>;
  selectedCount: any;
  deleteContinueFunction: Function;
  affectedPortfolios: Array<any>;
  grid: any;
  gridOptions: any;
  affectedPortfoliosGrid: any;
  affectedPortfoliosGridOptions: any;
  isUiTest = false;

  constructor(public dialogRef: MatDialogRef<DeleteExternalAccountsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public mdd: any,
    private cs: IrbClientsService,
    private as: AppService,
    private readonly assignedAccountsService: AssignedAccountsService,
    private gls: DeleteExternalAccountsDialogGridLayoutService) {

  }

  ngOnInit(): void {
    this.gridOptions = {
      columnDefs: this.gls.getColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.affectedPortfoliosGridOptions = {
      columnDefs: this.gls.getAffectedPortfoliosColumnDefs(),      
      floatingFilter: false,
      overlayNoRowsTemplate: "<span class='ag-overlay-loading-center ag-overlay-message'>No results.</span>",
      context: { componentParent: this }
    };

    this.externalAccounts = this.mdd.externalAccounts as Array<any>;
    this.selectedCount = this.mdd.selectedCount as any;
    this.affectedPortfolios = this.mdd.affectedPortfolios as Array<any>;
    this.deleteContinueFunction = this.mdd.deleteContinueFunction || null;
  }

  close() {
    this.dialogRef.close();
  }

  deleteSelectedExternalAccounts() {
    const request = {} as IExternalAccountRequest;
    request.isSelectAll = false;
    request.selectedIds = this.externalAccounts.map(account => account.accountId);
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.assignedAccountsService.confirmDeleteExternalAccounts(request).subscribe(data => {
    this.deleteContinueFunction(data);
    this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    this.close();

    });
  }
  onGridReady(params: any) {
    this.grid = params;
  }
  onAffectedPortfoliosGridReady(params: any) {
    this.affectedPortfoliosGrid = params;
  }

}
